<template>
  <van-popup v-model:show="show" :close-on-click-overlay="false">
    <div class="w-[360px]">
    <van-swipe :autoplay="5000" indicator-color="white">
      <van-swipe-item v-for="item in showList" :key="item.configId">
        <Image
          lazy-load
          :src="getImageUrl(item.picture)"
          class="w-full"
          @click="handleJumpLink(item, $router)"
        />
      </van-swipe-item>
    </van-swipe>
    <span class="closeIcon mx-auto mt-10" @click="close" />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
  import { getImageUrl, handleJumpLink } from '@/utils'
  import type { iPopupImage } from '@/types/index'

  const { items } = defineProps<{
    items: iPopupImage[]
  }>()

  const show = ref(true)

  const showList = ref<iPopupImage[]>(items)

  const close = () => {
    show.value = false
    showList.value = []
  }

  const tids: number[] = []

  const check = () => {
    const deferedToShow: Record<string, iPopupImage[]> = {}

    items.forEach(item => {
      if (item.interval) {
        if (item.interval in deferedToShow) {
          deferedToShow[item.interval].push(item)
        } else {
          deferedToShow[item.interval] = [item]
        }
      }
    })

    Object.entries(deferedToShow).forEach(([interval, items]) => {
      const tid = setInterval(() => {
        showList.value = [...items]
        show.value = true
      }, +interval * 3600 * 1000)

      tids.push(tid)
    })
  }

  check()

  onUnmounted(() => {
    tids.forEach(tid => clearInterval(tid))
  })

</script>
